import { useEffect } from 'react';
import { useUserStore } from '@/stores/user/userStore';
import useClaudeModelsModalStore from '@/stores/claudeModelsModal/claudeModelsModalStore';

/**
 * Hook to manage the Claude Models Modal
 * This hook should be used in components that are rendered after login
 * to check if the modal should be shown (once per user)
 */
const useClaudeModelsModal = () => {
  const user = useUserStore((state) => state.user);
  const auth = useUserStore((state) => state.auth);
  const clearJustLoggedIn = useUserStore((state) => state.clearJustLoggedIn);
  const { checkAndShowModal, reset } = useClaudeModelsModalStore();

  useEffect(() => {
    // Only check modal status if user just logged in (not on page refresh)
    if (user && auth?.access_token && auth?.just_logged_in) {
      // Show modal with a delay
      setTimeout(() => {
        checkAndShowModal();
      }, 500);

      // Clear the just_logged_in flag after checking
      clearJustLoggedIn();
    }

    // Reset modal state when user logs out
    if (!user || !auth?.access_token) {
      reset();
    }
  }, [user, auth?.access_token, auth?.just_logged_in, checkAndShowModal, reset, clearJustLoggedIn]);

  // Return the modal store for components that need direct access
  return useClaudeModelsModalStore();
};

export default useClaudeModelsModal;

